import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui";

/** Prev / next paging for lists that fetch `pageSize + 1` rows: the extra row only says whether a next page exists. */
export function Pager({ page, pageSize, count, onPage }: { page: number; pageSize: number; count: number; onPage: (p: number) => void }) {
  const { t } = useTranslation();
  const hasNext = count > pageSize;
  if (page === 0 && !hasNext) return null;
  const shown = Math.min(count, pageSize);
  return (
    <div className="flex items-center gap-2 text-xs text-muted">
      <Button type="button" variant="ghost" className="!px-2 !py-0.5" disabled={page === 0} onClick={() => onPage(page - 1)}>‹</Button>
      <span>{shown ? t("pager.range", { from: page * pageSize + 1, to: page * pageSize + shown }) : t("pager.empty")}</span>
      <Button type="button" variant="ghost" className="!px-2 !py-0.5" disabled={!hasNext} onClick={() => onPage(page + 1)}>›</Button>
    </div>
  );
}
